"use client";

import { TimelineContainer } from "./timeline-container";
import { AttractionTicketItineraryInner } from "./attraction-ticket-itinerary-inner";
import { iAttractionTicketLegDetails } from "@/@sdk/holiday-quotes-x/holiday-quotes-x-model";

export function AttractionTicketItinerary(
  props: iAttractionTicketLegDetails & { primaryColor?: string; day: number }
) {
  return (
    <TimelineContainer
      title={props.title || "Attraction"}
      icon={(props.icon as any) || "activity"}
    >
      <AttractionTicketItineraryInner {...props} day={props.day} />
    </TimelineContainer>
  );
}
